import React, { useState } from 'react'

const SelectButtons = (props) => {
  return (
    <div className='select-buttons-container'>
      <div className='fixed-buttons-container'>
        <div className='row'>
          <div className='col-sm-6'>
            <button
              className='btn btn-success confirm-select-button'
              onClick={() => props.onGamesSelect({...props.gamesSelector, action: 'confirm'})}
            >
              Confirm
            </button>
          </div>
          <div className='col-sm-6'>
            <button
              className='btn btn-danger cancel-select-button'
              onClick={() => props.onGamesSelect({...props.gamesSelector, action: 'cancel'})}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectButtons
